import React from 'react';
import { Tabs } from 'antd';
import Label from '../labels';
import ExcelLabel from './pages/excelLabel';
import Subscribers from './pages/subscribers';
import System from './pages/system';
import Connectors from './pages/connectors';
import PolarityTypes from './pages/polarityType';
import Security from './pages/security';
import CustomFields from './pages/customFields';

import './styles.scss';

const { TabPane } = Tabs;
export default class Settings extends React.PureComponent {
    leaveF() {
        let reportBro = document.getElementById('reportbro-frame').contentWindow.window.reportBroInstance;
        if (!reportBro.modified) {
            // No changes to document.
            // Leave Report Bro.
            //   this.setState({ reportBro: false });
            return;
            //   return `Are you sure you want to go to ${location.pathname}?  \n Your unsaved label could be lost if you leave this page  `;
        }
        // Unsaved changes. Show the Save/Discard modal
        // this.setState({ modalVisible: true });
        return `Are you sure you want to go to ?  \n Your unsaved label could be lost if you leave this page  `;
    }

    render() {
        return (
            <div id="settings-page">
                <div style={{ height: '35px' }}></div>

                <Tabs
                    defaultActiveKey="1"
                >
                    <TabPane tab={<div>Labels</div>} key="1">
                        <Label />
                    </TabPane>
                    <TabPane tab={<div>Excel</div>} key="1.5">
                        <ExcelLabel />
                    </TabPane>
                    <TabPane tab={<div>Custom Fields</div>} key="2">
                        <CustomFields />
                    </TabPane>
                    <TabPane tab={<div>Polarity Types </div>} key="3">
                        <PolarityTypes />
                    </TabPane>
                    <TabPane tab={<div>Connectors </div>} key="4">
                        <Connectors />
                    </TabPane>
                    <TabPane tab={<div> Subscribers </div>} key="4.5">
                        <Subscribers />
                    </TabPane>
                    <TabPane tab={<div> Security </div>} key="5">
                        <Security />
                    </TabPane>
                    <TabPane tab={<div>System</div>} key="6">
                        <System />
                    </TabPane>
                </Tabs>
            </div>
        );
    }
}
